<template>
  <div class="user-agreement-page">
    <!-- 顶部导航 -->
    <HeaderModel></HeaderModel>
    <div class="back-home" @click="goBack">
      <img
        class="back-icon"
        src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login3.png"
        alt=""
      />
      <span>返回首页</span>
    </div>
    <!-- 主要内容 -->
    <div class="main-content">
      <div class="content-wrapper">
        <h1 class="page-title">用户协议</h1>

        <div class="publish-date"><strong>生效及发布日期：</strong> 2026年3月11日</div>

        <p class="intro-text">
          欢迎您使用由<strong>北京温致科技有限公司</strong>（以下简称“本公司”）运营的AI健康监测网页版服务。在通过手机号码注册并使用本服务前，请您务必审慎阅读、充分理解本协议的各项条款。
        </p>

        <!-- 章节一 -->
        <div class="section">
          <h2 class="section-title">一、服务说明</h2>
          <p class="section-content">
            本服务是一款基于网页端的AI健康监测工具。用户在使用手机号码及验证码/密码完成注册并登录后，可通过授权网页调用设备摄像头录制30秒面部视频，系统将结合第三方（北京微面科技有限公司）的技术接口，为您生成关于心率、HRV、压力水平、呼吸率等指标的AI分析报告。
          </p>
        </div>

        <!-- 章节二 -->
        <div class="section">
          <h2 class="section-title">二、核心免责声明（请您务必仔细阅读）</h2>
          <ul class="list-content">
            <li>
              <strong>非医疗用途：</strong>
              本服务所提供的所有AI分析报告及健康监测数据仅供用户个人日常健康关注与参考，绝不构成任何形式的医疗诊断、治疗建议或专业临床医疗意见。
            </li>
            <li>
              <strong>数据准确性限制：</strong>
              视频采集与数据分析过程受环境光线、背景杂乱度、设备摄像头像素、用户面部遮挡物及测量时的运动/情绪状态等多种外部因素影响，本公司不对最终输出数据的绝对准确性、完整性作出任何法律保证。若您感到身体不适或有明确的医疗需求，请立即前往正规医疗机构就诊。
            </li>
          </ul>
        </div>

        <!-- 章节三 -->
        <div class="section">
          <h2 class="section-title">三、服务地域限制</h2>
          <p class="section-content">
            本服务仅限在中国大陆地区内使用。系统将自动识别用户的IP地址，任何来自中国大陆以外的IP访问请求将被系统拒绝。用户不得通过VPN、代理服务器等任何技术手段绕过此地域限制，否则本公司有权单方面中止或终止为您提供服务，并封禁您的手机号账号。
          </p>
        </div>

        <!-- 章节四 -->
        <div class="section">
          <h2 class="section-title">四、用户的权利与义务</h2>
          <ul class="list-content">
            <li>您承诺在注册时提供真实、准确、合法的本人手机号码。</li>
            <li>
              您应妥善保管自己的手机登录验证码和密码，并对该账号下发生的所有行为和结果负责。
            </li>
            <li>
              您在使用本服务时，必须严格遵守中华人民共和国相关法律法规，不得利用本服务从事任何违法、违规或侵犯他人合法权益（包括但不限于肖像权、隐私权）的行为。未经他人明确同意，您不得使用本服务扫描或录制他人的面部视频。
            </li>
            <li>
              您理解并明确同意，使用本服务即代表您授权本公司及我们的技术合作方（北京微面科技有限公司）处理您的面部视频以生成分析报告。
            </li>
          </ul>
        </div>

        <!-- 章节五 -->
        <div class="section">
          <h2 class="section-title">五、服务的变更、中断与终止</h2>
          <p class="section-content">
            本公司保留在法律允许的范围内，根据业务发展需要随时修改、升级、中断或终止部分或全部网络服务的权利。对于因常规系统维护、软硬件升级或不可抗力（如网络故障、黑客攻击、政策变动等）导致的服务中断，本公司尽力减小影响，但不承担由此产生的直接或间接损失。
          </p>
        </div>

        <!-- 章节六 -->
        <div class="section">
          <h2 class="section-title">六、法律适用与争议解决</h2>
          <p class="section-content">
            本协议的成立、生效、履行、解释及纠纷解决，均适用中华人民共和国大陆地区法律。如双方就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，任何一方均可向<strong
              >北京温致科技有限公司</strong
            >所在地有管辖权的人民法院提起诉讼。
          </p>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <FooterModel
      style="position: absolute; bottom: 0; left: 0; right: 0"
    ></FooterModel>
  </div>
</template>

<script>
import HeaderModel from "@/components/HeaderModel.vue";
import FooterModel from "@/components/FooterModel.vue";
export default {
  components: {
    FooterModel,
    HeaderModel,
  },
  name: "UserAgreement",
  data() {
    return {};
  },
  methods: {
    goBack() {
      // this.$router.go(-1);
      this.$router.replace({ path: "/", force: true });
    },},
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .user-agreement-page {
    min-height: 100vh;
    background: linear-gradient(73deg, #e8f2ff 0%, #ffffff 50%, #f4f1ff 100%);
    position: relative;
    .back-home{
      display: none;
    }
    .main-content {
      max-width: 87.5rem;
      margin: 0 auto;
      padding: 3rem 2.5rem;
      padding-bottom: 12rem;

      .content-wrapper {
        .page-title {
          font-size: 2.2rem;
          font-weight: bold;
          color: #1a1a1a;
          margin-bottom: 1.65rem;
        }

        .publish-date {
          font-size: 1.2rem;
          color: #1a1a1a;
          margin-bottom: 1.65rem;
        }

        .intro-text {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #333333;
          margin-bottom: 2.2rem;

          strong {
            font-weight: 600;
          }
        }

        .section {
          margin-bottom: 2.2rem;

          .section-title {
            font-size: 1.3rem;
            font-weight: bold;
            color: #1a1a1a;
            margin-bottom: 1.1rem;
          }

          .section-content {
            font-size: 1.1rem;
            line-height: 2;
            color: #333333;
            text-align: justify;

            strong {
              font-weight: 600;
            }
          }

          .list-content {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
              font-size: 1.1rem;
              line-height: 2;
              color: #333333;
              margin-bottom: 0.77rem;
              padding-left: 1.375rem;
              position: relative;
              text-align: justify;

              &::before {
                content: "•";
                position: absolute;
                left: 0;
                color: #1890ff;
                font-size: 1.76rem;
                line-height: 1;
              }

              strong {
                font-weight: 600;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .back-home {
      width: 42.375rem;
      margin: auto;
      padding-top: 2.625rem;
      display: flex;
      align-items: center;
      color: #333;
      font-weight: 600;
      font-size: 1.75rem;
      color: #4e5361;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 2.25rem;
        height: 2.25rem;
        margin-right: 1.1rem;
      }
    }
  .user-agreement-page {
    min-height: 100vh;
    background: linear-gradient( 15deg, #F4F1FF 0%, #FFFFFF 45%, #E8F2FF 100%);
    position: relative;

    .main-content {
      max-width: 87.5rem;
      margin: 0 auto;
      padding: 3rem 2.5rem;
      padding-bottom: 14rem;

      .content-wrapper {
        .page-title {
          font-size: 2.2rem;
          font-weight: bold;
          color: #1a1a1a;
          margin-bottom: 1.65rem;
        }

        .publish-date {
          font-size: 1.7rem;
          color: #1a1a1a;
          margin-bottom: 1.65rem;
        }

        .intro-text {
          font-size: 1.6rem;
          line-height: 1.8;
          color: #333333;
          margin-bottom: 2.2rem;

          strong {
            font-weight: 600;
          }
        }

        .section {
          margin-bottom: 2.2rem;

          .section-title {
            font-size: 2rem;
            font-weight: bold;
            color: #1a1a1a;
            margin-bottom: 1.1rem;
          }

          .section-content {
            font-size: 1.6rem;
            line-height: 2;
            color: #333333;
            text-align: justify;

            strong {
              font-weight: 600;
            }
          }

          .list-content {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
              font-size: 1.6rem;
              line-height: 2;
              color: #333333;
              margin-bottom: 0.77rem;
              padding-left: 1.375rem;
              position: relative;
              text-align: justify;

              &::before {
                content: "•";
                position: absolute;
                left: -0.4rem;
                color: #1890ff;
                font-size: 3.4rem;
                line-height: 0.8;
              }

              strong {
                font-weight: 600;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>